import { useCallback, useMemo } from 'react';

export default ({
  paramsId,
  routeMatchUrl = '',
  parentPath = '',
}: {
  paramsId?: number | string;
  routeMatchUrl?: string;
  parentPath?: string;
}) => {
  const id = useMemo(() => {
    return window.location.pathname.includes(routeMatchUrl)
      ? paramsId
      : undefined;
  }, [window.location.pathname, routeMatchUrl, paramsId]);

  const onExited = useCallback(() => {
    window.history.replaceState(null, '', parentPath);
  }, [parentPath]);

  return {
    id,
    onExited,
  };
};
